import * as yup from 'yup'

const schema = (customDpo, noDpo) => {
  const isEmailRequired = customDpo || noDpo

  return yup.object().shape({
    email: isEmailRequired
      ? yup.string().email().required()
      : yup.string().email(),
  })
}

export default schema
